<router-outlet></router-outlet>
<ngx-loading [show]="loadingService.loading" [config]="{ backdropBorderRadius: '3px' }">
</ngx-loading>